import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AppConstants } from '@app/@core/entities/app-constants';
import { AlertService } from '@app/@core/services/alert.service';
import { AttachmentsService } from '@app/@core/services/attachments.service';
import { HttpService } from '@app/@core/services/http.service';
import { LocalService } from '@app/@core/services/local.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { ChatService } from '../@core/services/chat.service';

@Component({
  standalone: false,
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss']
})
export class DocumentUploadComponent implements OnInit {
  @Output() uploadedDocument = new EventEmitter();
  @Input() case_id: number;
  @Input() person_id: number;
  @Input() receiver_id: number;
  @Input() is_fileshare: boolean;
  @Input() is_fileupload: boolean;
  documentUploadForm: UntypedFormGroup;
  httpService: HttpService;
  attachmentService: AttachmentsService;
  localService: LocalService;
  userId: number;
  alertService: AlertService;
  chatService: ChatService;
  documentTypes: any[] = [];
  childList: any[] = [];
  documentCategories: any[] = [];

  constructor(injector: Injector, private modalService: NgbModal, private formBuilder: UntypedFormBuilder) {
    this.httpService = injector.get<HttpService>(HttpService);
    this.attachmentService = injector.get<AttachmentsService>(AttachmentsService);
    this.localService = injector.get<LocalService>(LocalService);
    this.alertService = injector.get<AlertService>(AlertService);
    this.chatService = injector.get<ChatService>(ChatService);
    this.userId = Number(this.localService.getItem('id'));
  }

  ngOnInit(): void {
    this.initializeDocumentUploadForm();
    this.getChildByCase();
  }

  initializeDocumentUploadForm() {
    this.documentUploadForm = this.formBuilder.group({
      id: [],
      documenttype: ['', Validators.required],
      filename: [],
      file_type: [],
      title: ['', Validators.required],
      documentdate: [],
      documentdesc: [],
      orginalfilename: [],
      documenturl: [],
      document_size: [],
      objecttype: [],
      chatid: [],
      remarks: [],
      isactive: true,
      externalid: [],
      documentcategory: ['', Validators.required],
      submitteddate: [],
      submittedby: [],
      personid: [],
      caseid: [],
      issendtoshine: true,
      sendtoshinedt: [],
      approvalrejectremarks: [],
      approverejectby: [],
      approverejectdt: [],
      status: [],
      touserid: [],
      toroleid: [],
      uploadsource: ['Chat']
    });
  }

  closeDocumentUploadModal() {
    this.modalService.dismissAll();
  }

  getChildByCase() {
    this.chatService.getChildByCase(this.case_id).subscribe(
      res => {
        this.childList = res['data'];
      },
      _error => this.alertService.error(AppConstants.errorMessage)
    );
  }

  uploadFile(fileValue: any) {
    const fileName = fileValue[0].name;
    const fileSize = Number(fileValue[0].size);
    const filetype = fileValue[0].type;
    const imageData = {
      contentType: fileValue[0].type,
      fileName: `cardyChat/${this.userId}/${new Date().toISOString()}/${fileName.replaceAll(' ', '')}`
    };
    if (this.validateDocument(fileValue[0])) {
      this.attachmentService.uploadKey(imageData).subscribe(
        (res: any) => {
          const urlPath = res.data;
          this.httpService.putUpload(urlPath, fileValue[0], filetype).subscribe(
            (_resp: any) => {
              this.documentUploadForm.patchValue({
                filename: fileName,
                document_size: fileSize,
                file_type: filetype,
                documentdate: moment().format(),
                documenturl: imageData.fileName,
                orginalfilename: fileName,
                submitteddate: moment().format(),
                sendtoshinedt: moment().format(),
                submittedby: String(this.userId),
                touserid: Number(this.receiver_id),
                caseid: String(this.case_id),
                personid: String(this.person_id)
              });
            },
            error => {
              if (!error.status) {
                this.alertService.error(AppConstants.errorMessage);
              }
            }
          );
        },
        _error => {
          this.alertService.error(AppConstants.errorMessage);
        }
      );
    }
  }

  validateDocument(file: any) {
    const fileSize = Number(file.size) / 1024;
    const filetype = file.type.split('/')[1];
    if (filetype === 'jpg' || filetype === 'jpeg' || filetype === 'pdf') {
      if (fileSize < 5000) {
        return true;
      } else {
        this.alertService.warn('File is bigger than 5 MB');
        return false;
      }
    } else {
      this.alertService.warn(`${filetype.toLocaleUpperCase()} format is not supported`);
      return false;
    }
  }

  clearDocument() {
    this.documentUploadForm.reset();
  }

  sendDocument() {
    if (this.is_fileupload) {
      if (this.documentUploadForm.valid) {
        this.uploadedDocument.emit(this.documentUploadForm.value);
        this.modalService.dismissAll();
      } else {
        this.alertService.warn('Please Fill Required Fields');
      }
    } else {
      this.uploadedDocument.emit(this.documentUploadForm.value);
      this.modalService.dismissAll();
    }
  }
}
